var React = require('react');

function LineMobile2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M126.054 0.570312V8.48592C126.054 24.9768 112.685 38.3453 96.1945 38.3453H0","stroke":"white","strokeWidth":"2.15"}));
}

LineMobile2.defaultProps = {"width":"128","height":"40","viewBox":"0 0 128 40","fill":"none"};

module.exports = LineMobile2;

LineMobile2.default = LineMobile2;
